import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import InputSelect from '../../../Components/InputSelect';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import { SelectPicker } from 'rsuite';

const CreateCompany = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const date = new Date();

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    const regionNames = [
        "Southeast Asia",
        "North America",
        "South America",
        "Europe",
        "Africa",
        "Oceania",
    ].map(
        item => ({ label: item, value: item })
    );

    const [useGurope, setUserGurope] = useState('OFF');
    const [dispatchRole, setDispatchRole] = useState('ON');

    const [checkedCreateGroupe, setCheckedCreateGroupe] = useState(false);

    const [companyNameList, setCompanyNameList] = useState([]);

    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/companys/get`,
                {
                    headers: {
                        "Content-Type": "application/json", // Specify content type
                        Authorization: `Bearer ${token}`, // Include the token
                    },
                }
            )
                .then(response => {
                    // console.log('agentData', response.data.data);
                    const companyList = response.data.data;
                    const existingCompanyNames = companyList.map(company => company.name);
                    setCompanyNameList(existingCompanyNames);
                })
                .catch(error => {
                    console.error("There was an error fetching the customer data!", error);
                });
        }
        fetch();
    }, []);

    const [companyData, setCompanyData] = useState({
        name: '',
        account: '',
        password: '',
        contacts: '',
        region: null,
        detailed_address: '',
    });

    const handleCompanyChange = (e) => {
        setCompanyData({
            ...companyData,
            [e.target.name]: e.target.value,
        });
    };
    const handleRegionChange = (value) => {
        setCompanyData((prevData) => ({
                ...prevData,
                region: value, // Update the country in the state
        }));
    };
    const handleDataFromChild = (data) => {
        setCompanyData({
            ...companyData,
            ['region']: data,
        });
    };

    const regex1 = /^(?!_)[a-zA-Z0-9_]{4,20}$/;//4-20 characters, includes letters, numbers, underscores, and does not start with an underscore.
    const regex2 = /^(?!_)[a-zA-Z0-9_]{6,20}$/;//Contains 6-20 numbers, letters, underlines, but not starts with underline
    const regex3 = /^[a-zA-Z0-9]{6,16}$/;//contains 6-16 digits of letters and numbers
    const regex4 = /^(?!_)[a-zA-Z0-9_]{2,10}$/;//Contains 2-10 numbers, letters, underlines, but not starts with underline

    const [error, setError] = useState("");

    const handleCompanyCreate = async() => {
        try {

            console.log(companyData);
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            if (regex1.test(companyData.name)) {
                if (companyNameList.includes(companyData.name)) {
                    toast.warn("A company with this name already exists!", {
                        className: 'centered-toast2',
                        bodyClassName: 'centered-body',
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeButton: false,
                        pauseOnHover: false,
                        draggable: true,
                      });
                    return;
                } else {
                    setError("");
                }
              } else {
                toast.warn("Company name contains 4-20 numbers, letters, underlines, but not starts with underline", {
                    className: 'centered-toast1',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
              }
            if (regex2.test(companyData.account)) {
                setError("");
              } else {
                toast.warn("Account contains 6-20 numbers, letters, underlines, but not starts with underline", {
                    className: 'centered-toast1',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
              }
            if (regex3.test(companyData.password)) {
                setError("");
              } else {
                toast.warn("Password contains 6-16 digits of letters and numbers", {
                    className: 'centered-toast2',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
              }
            if (regex4.test(companyData.contacts)) {
                setError("");
              } else {
                toast.warn("Contact person should contain 2-10 numbers, letters, underlines, but not start with underline", {
                    className: 'centered-toast3',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (companyData.region) {
                setError("");
              } else {
                toast.warn("Please select region", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            const response = await axios.post(`${POCBaseUrl}/companys/create`, {companyData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token ,  // Include the token
                    },
                  }
            );

            if(response.data.success) {
                toast.success("Created successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });

                navigate('/companylist');
            } else {
                toast.warn("Creation failed!", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                });
            }
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <form className='m-0 p-0'>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Name'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'name'} value={companyData.name || ''} onChange={handleCompanyChange} placeholder={'Please enter agent name'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 4-20 numbers, letters, underlines, but not starts with underline</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Account'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'account'} value={companyData.account || ''} onChange={handleCompanyChange} placeholder={'Please input account'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 6-20 numbers, letters, underlines, but not starts with underline</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Password'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'password'} value={companyData.password || ''} onChange={handleCompanyChange} type={'password'} placeholder={'Please input the login password'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>contains 6-16 digits of letters and numbers</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Contacts'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'contacts'} value={companyData.contacts || ''} onChange={handleCompanyChange} placeholder={'Please input contact person'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-10 numbers, letters, underlines, but not starts with underline</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Region'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <SelectPicker data={regionNames} value={companyData.region || ''} onChange={handleRegionChange} appearance="default" placeholder="" className="w-[360px] !h-[40px]" />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select region</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Detailed address'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'detailed_address'} value={companyData.detailed_address || ''} onChange={handleCompanyChange} placeholder={'Please enter detailed address'} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className='mt-2.5 bg-[#f0f0f0]'>
                <button onClick={() => handleCompanyCreate()} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2.5 px-24 rounded text-white cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>
                    Save
                </button>
            </div>
        </>
    );
}

export default CreateCompany;